import { render, staticRenderFns } from "./FiltersERCProtocols.vue?vue&type=template&id=80b89a56&scoped=true&"
import script from "./FiltersERCProtocols.vue?vue&type=script&lang=ts&"
export * from "./FiltersERCProtocols.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersERCProtocols.vue?vue&type=style&index=0&id=80b89a56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b89a56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
